module.exports = __webpack_public_path__ + "img/5b138bf993dd0e3fdfc4470c9f2b1a98.svg";